import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex, Box } from 'reflexbox'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import injectSagas from 'helpers/injectSagas'

import Dialog from './Dialog'
import UploadPage from './UploadPage'

import {
  MAX_SIZE,
  MODULE_NAME,
  FILE_ACCEPT_TYPE
} from './constants'

import {
  fileSourceSelector,
  activeSelector,
  pageSelector,
  fileTypeSelector,
  internalSelector,
} from './selectors'

import {
  segmentSelector
} from 'containers/Project/View/selectors'

import {
  setInactive,
  setUploadPage,
  updateFileType,
  dropRejected,
  postUploadFile,
  updateInternal
} from './actions'

import sagas from './sagas'

import styles from './styles.scss'

const mapStateToProps = (state) => {
  return {
    active: activeSelector(state),
    internal: internalSelector(state),
    page: pageSelector(state),
    fileType: fileTypeSelector(state),
    segment: segmentSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    disableDialog: () => dispatch(setInactive()),
    onNextClick: () => dispatch(setUploadPage()),
    onFileTypeChange: (value) => dispatch(updateFileType(value)),
    onDropRejected: (files) => dispatch(dropRejected(files)),
    onDropAccepted: (files) => dispatch(postUploadFile(files)),
    onCheck: (value) => dispatch(updateInternal(value))
  }
}

const FulcrumUploadDialog = props => {
  const {
    active,
    page,
    fileType,
    disableDialog,
    onNextClick,
    onFileTypeChange,
    onDropAccepted,
    onDropRejected,
    onCheck,
    internal,
    segment
  } = props

  return (
    <Dialog
      active={active}
      onEscKeyDown={disableDialog}
      onOverlayClick={disableDialog}
    >
      <UploadPage
        internal={internal}
        onCheck={onCheck}
        onNextClick={onNextClick}
        onFileTypeChange={onFileTypeChange}
        page={page}
        fileType={fileType}
        onDropAccepted={onDropAccepted}
        onDropRejected={onDropRejected}
        maxSize={MAX_SIZE}
        accept={FILE_ACCEPT_TYPE.join(', ')}
        segment={segment}
      />
    </Dialog>
  )
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({[MODULE_NAME]: sagas})

const enhance = compose(
  withSagas,
  withConnect,
  withStyle
)

export default enhance(FulcrumUploadDialog)
